import Popover from '../../../../components/common/popover/Popover'
import styles from './SkillsPopover.module.less'
import { useMemo } from 'react'
import Tag from '../../../../components/common/tag/Tag'
import { DataTestId, TextConstants } from 'src/constants/ui.constants'

const { Skills } = TextConstants.SkillsPopover

export type SkillsPopoverProps = {
    skills: string[]
    children: React.ReactNode
}

const SkillsPopover: React.FC<SkillsPopoverProps> = props => {
    const popoverContent = useMemo(() => {
        const sortedSkills = [...props.skills].sort()

        return (
            <div className={styles.skillsPopover}>
                <div className={styles.flex}>
                    {sortedSkills.map((skill, index) => (
                        <Tag
                            key={index}
                            label={skill}
                            textWeight={'medium'}
                            color={'cloud'}
                            textAlign={'left'}
                            isRounded
                            textWrap={'wrap'}
                        />
                    ))}
                </div>
            </div>
        )
    }, [props.skills])

    return (
        <div data-testid={DataTestId.SkillsPopover}>
            <Popover
                content={popoverContent}
                title={
                    <div className={styles.title}>
                        {props.skills.length} {Skills}
                    </div>
                }
            >
                {props.children}
            </Popover>
        </div>
    )
}

export default SkillsPopover
